/* eslint-disable no-restricted-syntax */
/* eslint-disable no-console */
import React, { useState } from 'react';
import { Menu, Grid, ListItemText } from '@mui/material';
import UIGrid from '../uigrid';

function checkValue(value) {
  const absValue = Math.abs(value);
  if (absValue === 0) {
    return 0;
  } if (absValue >= 0.01) {
    return value.toFixed(2);
  } if (absValue < 0.01) {
    return '< 0.01';
  }
  return value;

};
const MassBalance = (props) => {
  const { massBalanceAnchorEl, translateObject, setMassBalanceAnchorEl, MassBalanceOpen, report_invoice } = props;
  const reportData = report_invoice.report_dict;
  // const [anchorEl, setAnchorEl] = React.useState(null);
  // const storageData = JSON.parse(localStorage.getItem('ro_ouput_data')) || {};
  // function getJsonData(data, unitTypeValue) {
  //   const result = [];
  //   for (const [key, value] of Object.entries(data)) {
  //     if (value.unit_type && value.unit_type === unitTypeValue) {
  //       result.push({ [key]: value });
  //     }
  //   }
  //   return result;
  // }

  function convertData(dummydata) {
    return Object.entries(dummydata)
      .filter(([key]) => key !== 'Overall_Flag')
      .map(([key, value]) => ({
        parameter: key,
        value: value.MB,
        flowbalance: checkValue(value.diff),
      }));
  };
  // Convert the data
  const massBalanceData = convertData(reportData?.massbal_dict || {});
  const handleClose = () => {
    setMassBalanceAnchorEl(null);
  };
  const [columnDefs2] = useState([
    { tag: 'parameter', hdata: 'Unit Name', datatype: 'text', disabled: true },
    { tag: 'flowbalance', hdata: 'Flow Balance (%)', datatype: 'text', disabled: true },
    // { tag: 'value', hdata: 'Flag', datatype: 'text', disabled: true }
  ]);
  return (
    <Menu
      id="demo-positioned-menu"
      MenuListProps={{
        'aria-labelledby': 'lock-menu',
      }}
      anchorEl={massBalanceAnchorEl}
      keepMounted
      open={MassBalanceOpen}
      onClose={handleClose}
      sx={{ 'zIndex': 999 }}
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: 'visible',
          // maxWidth: ReportRadio === '0' ? '100vh' : '45vw',
          padding: '16px',
          filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
          mt: 1.5,
          '& .MuiAvatar-root': {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
          },
          '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            bgcolor: '#F2F1F9',
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0,
          },
        },
      }}
      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      {/* <MenuItem onClick={e => handleSubMenuOpen(e, '0')}> */}
      <ListItemText>{translateObject('Mass Balance Report')}</ListItemText>
      {/* </MenuItem> */}
      <Grid container className='pdfOption' spacing={2} direction="row">
        <Grid item xs={12} className='pdfOptinMenu' style={{ maxHeight: '200px', overflow: 'auto', marginTop: '24px', paddingTop: '0px' }}>
          <UIGrid
            data={massBalanceData}
            properties={columnDefs2}
            tableClassName='massBalance_data'
          />
        </Grid>
      </Grid>
    </Menu>
  );
};

export default MassBalance;